import api from '../../api'

export default function getCategories() {
  return api.get(`/brands/manage/categories`);
}